function initRmxAbout() {
  $(".about-tiles li").each(function () {
    $(this).prepend(
      $("<span />", {
        class: "about-tiles__number",
        html: "<span><span><span></span></span></span>",
      })
    );
  });
}
